const ITEM_FIELD_ORDER = ["quantity", "reason", "images", "resolution"];
const ORDER_FIELD_ORDER = ["reason", "images", "details", "resolution"];

/**
 * Re-clicking the issue type that is already selected keeps the reason,
 * resolution, and photos. Switching to the other type still clears them.
 */
export function applyIssueTypeClick(currentIssueType, clickedType) {
  if (currentIssueType === clickedType) {
    return { issueType: clickedType, resetDependentFields: false };
  }

  return { issueType: clickedType, resetDependentFields: true };
}

export function firstInvalidClaimField(errors) {
  if (!errors || typeof errors !== "object") return null;

  if (Array.isArray(errors.items)) {
    for (let index = 0; index < errors.items.length; index += 1) {
      const item = errors.items[index];
      if (!item || typeof item !== "object") continue;

      for (const key of ITEM_FIELD_ORDER) {
        if (item[key]) return `items.${index}.${key}`;
      }
    }
  }

  for (const key of ORDER_FIELD_ORDER) {
    if (errors[key]) return key;
  }

  return null;
}

export function scrollFieldIntoView(fieldName) {
  if (!fieldName || typeof document === "undefined") return false;

  const selector = `[data-claim-field="${CSS.escape(fieldName)}"]`;
  const el = document.querySelector(selector);
  if (!el) return false;

  el.scrollIntoView({ behavior: "smooth", block: "center" });

  const focusable = el.matches("input, textarea, select, button")
    ? el
    : el.querySelector("input, textarea, select, button");
  focusable?.focus?.({ preventScroll: true });

  return true;
}
